import styled from 'vue-styled-components'
import colors from '@/components/kit/theme'

const componentProps = {
  background: [String, Array],
  backgroundOpacity: Number,
  border: String,
  borderRadius: String,
  text: String,
  gradientPercentage: Number
}

const EnergyVisualisationGradient = styled('div', componentProps)`
  background-color: ${(props) =>
    props.backgroundOpacity == null
      ? colors.knownColor(props.background)
      : colors.knownColorWithOpacity(
          props.background,
          props.backgroundOpacity
        )};
  border: ${(props) => (props.border == null ? '' : '1px solid')}
    ${(props) => (props.border == null ? '' : colors.knownColor(props.border))};
  border-color: ${(props) => colors.knownColor(props.border)};
  color: ${(props) => colors.knownColor(props.text)};
  border-radius: ${(props) => props.borderRadius};

  &.gradient {
    background: ${(props) => colors.knownColor(props.background[0])};
    background: -moz-linear-gradient(
      135deg,
      ${(props) => colors.knownColor(props.background[0])} ${(props) =>
  props.gradientPercentage}%,
      ${(props) => colors.knownColor(props.background[1])} 110%
    );
    background: -webkit-linear-gradient(
      135deg,
      ${(props) => colors.knownColor(props.background[0])} ${(props) =>
  props.gradientPercentage}%,
  ${(props) => colors.knownColor(props.background[1])} 110%
    );
    background: linear-gradient(
      135deg,
      ${(props) => colors.knownColor(props.background[0])} ${(props) =>
  props.gradientPercentage}%,
      ${(props) => colors.knownColor(props.background[1])} 110%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(
        startColorstr='${(props) => colors.knownColor(props.background[0])}',
        endColorstr='${(props) => colors.knownColor(props.background[1])}',
        GradientType=1
      );
  }
`

export default {
  props: {
    background: [String, Array],
    backgroundOpacity: Number,
    border: String,
    borderRadius: String,
    text: String,
    gradientPercentage: Number
  },
  render(h) {
    return (
      <EnergyVisualisationGradient
        class="color gradient"
        background={this.background}
        background-opacity={this.backgroundOpacity}
        border={this.border}
        border-radius={this.borderRadius}
        text={this.text}
        gradient-percentage={this.gradientPercentage}
      >
        {this.$slots.default}
      </EnergyVisualisationGradient>
    )
  }
}
